import Image from "next/image";
import React from "react";
import AspectRatioComponent from "~/components/aspect-ratio";
import GlowingButton from "~/components/reusables/glowing-button";
import { LinkTrackers } from "~/components/reusables/link-trackers";

export const ResourceDownloadable = ({ attributes }) => {
  return (
    <div className="relative overflow-hidden">
      <div className="container relative rounded-lg border border-white bg-black bg-cover bg-center py-14">
        <div className="hidden lg:block">
          <Image
            src="https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/downloadable-bg.svg"
            alt="Background"
            fill
            priority
            className="object-cover"
          />
        </div>
        <div className="absolute right-0 top-[8px] z-0 h-[380px] w-full sm:w-[630px] lg:hidden">
          <Image
            src="https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/collection-bg.png"
            alt="Background"
            fill
            priority
            className="object-cover"
          />
        </div>
        <div className="absolute right-0 top-[8px] z-20 h-[380px] w-full bg-gradient-to-tr from-black via-[#000000c0] to-[#fff0] sm:w-[630px] lg:hidden"></div>
        <div className="absolute bottom-0 left-0 z-0 h-[280px] w-[430px] lg:hidden">
          <Image
            src="https://outshift-headless-cms-s3.s3.us-east-2.amazonaws.com/downloadable-bg-bottom.svg"
            alt="Bottom Background"
            fill
            priority
            className="object-cover"
          />
        </div>
        <div className="absolute bottom-0 left-0 z-20 h-[280px] w-[430px] bg-gradient-to-bl from-black via-[#000000c0] to-[#fff0] lg:hidden"></div>
        <div className="absolute left-0 top-0 h-[8px] w-full rounded-t-lg bg-gradient-blue-purple"></div>
        <div className="relative z-40 flex flex-col items-center md:gap-[100px] lg:flex-row">
          <div className="flex flex-col md:flex-1">
            <h6 className="font-btn mb-3 uppercase text-white">
              featured ASSET
            </h6>
            <h3 className="font-hero-title md:font-h5 text-white">
              {attributes.header}
            </h3>
            <p className="font-p-sm py-6 text-white md:bg-gradient-to-b md:from-black md:to-[#00000000]">
              {attributes.description}
            </p>
            <div className="flex">
              <div className="hidden md:block">
                <GlowingButton>
                  <LinkTrackers
                    href={attributes.file.data[0].attributes.url}
                    target="_blank"
                    className="font-btn-lg px-auto px-2 py-3"
                    segmentMsg="Downloadable clicked"
                    segmentOpt={{
                      link_label: attributes.cta.cta,
                      location: "header",
                      resource_interaction: "read a PDF",
                      file_name: attributes.file.data[0].attributes.url
                        .split("/")
                        .pop(),
                      resource_type: "white paper",
                      resource_author:
                        attributes.header ==
                        "Welcome to the future of agentic AI: The Internet of Agents"
                          ? "Vijoy Pandey, Ph.D"
                          : "",
                      is_gated_asset: "false",
                    }}
                  >
                    {attributes.cta.cta}
                  </LinkTrackers>
                </GlowingButton>
              </div>
            </div>
            <p className="font-p-sm hidden pt-6 italic text-white md:block">
              * No email required
            </p>
          </div>
          <div className="w-full flex-1 md:flex-[.9]">
            <AspectRatioComponent
              aspectRatio={{
                width: attributes?.image.data.attributes.width,
                height: attributes?.image.data.attributes.height,
              }}
            >
              <Image
                unoptimized
                src={attributes?.image.data.attributes.url}
                fill
                alt="thumbnail"
                className="w-[90%] object-cover"
                sizes="100%"
              />
            </AspectRatioComponent>
          </div>
        </div>
        <div className="relative z-40 flex justify-end pt-6 md:hidden">
          <GlowingButton>
            <LinkTrackers
              href={attributes.file.data[0].attributes.url}
              target="_blank"
              segmentMsg="Downloadable clicked"
              segmentOpt={{
                link_label: attributes.cta.cta,
                location: "header",
                resource_interaction: "read a PDF",
                file_name: attributes.file.data[0].attributes.url
                  .split("/")
                  .pop(),
                resource_type: "white paper",
                resource_author:
                  attributes.header ==
                  "Welcome to the future of agentic AI: The Internet of Agents"
                    ? "Vijoy Pandey, Ph.D"
                    : "",
                is_gated_asset: "false",
              }}
            >
              {attributes.cta.cta}
            </LinkTrackers>
          </GlowingButton>
        </div>
        <p className="font-p-sm relative z-30 pt-6 text-right italic text-white md:hidden">
          * No email required
        </p>
      </div>
    </div>
  );
};
